export const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
export const todayStr = () => new Date().toISOString().slice(0, 10);

export const fmtIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style:"currency", currency:"IDR", minimumFractionDigits:0, maximumFractionDigits:0 }).format(n || 0);

export const fmtShort = (n) => {
  const abs = Math.abs(n || 0);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000_000) return sign + (abs / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (abs >= 1_000_000)     return sign + (abs / 1_000_000).toFixed(1).replace(/\.0$/, "") + "jt";
  if (abs >= 1_000)         return sign + (abs / 1_000).toFixed(0) + "rb";
  return sign + abs;
};

export const fmtNum = (v) => (v || v === 0 ? Number(v).toLocaleString("id-ID") : "");
export const parseNum = (s) => Number(String(s).replace(/\D/g, "")) || 0;

export const parseDec = (s) => {
  if (typeof s === "number") return s;
  const cleaned = String(s).replace(/[^\d.,]/g, "").replace(/\./g, "").replace(",", ".");
  return Number(cleaned) || 0;
};

export const fmtDec = (v) => {
  if (v === "" || v == null) return "";
  return Number(v).toLocaleString("id-ID", { maximumFractionDigits: 8 });
};

export const allowDecInput = (raw) => raw.replace(/[^\d,]/g, "").replace(/(,.*),/g, "$1");
